import { FALLBACK_IMAGES } from "@dl/declarations"
import { useState } from "react"

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
    fallbackImage?: keyof typeof FALLBACK_IMAGES
}

export const SystemImage: React.FC<ImageProps> = (props) => {
    const { src, fallbackImage = 'LLAMA', ...restOfProps } = props

    const [usedSrc, setUsedSrc] = useState<string | undefined>(src || FALLBACK_IMAGES[fallbackImage])

    return (
        <img
            {...restOfProps}
            src={usedSrc}
            onError={() => {
                setUsedSrc(FALLBACK_IMAGES[fallbackImage])
            }}
        />
    )
}
